import { graphql } from 'react-relay';

/**
 * Complimentary Pro on the operator surface. Both are gated to a named Entra operator (the break-glass
 * API key gets a 403) and both require a non-blank reason of at most 1000 characters, recorded on the
 * operations-side write audit. Refusals arrive as top-level errors carrying a code — see
 * `pro-grant-errors`. Neither payload carries the grant facts vault detail shows, so the screen refetches
 * the detail on success. Kept in `relay/` so the `graphql` tag stays in Babel-transformed data modules.
 */

/** Grant a vault Complimentary Pro for a term; re-granting a live comp extends it. */
export const grantProMutation = graphql`
    mutation proGrantMutationsGrantProMutation($vaultId: UUID!, $term: GrantTerm!, $reason: String!) {
        grantPro(vaultId: $vaultId, term: $term, reason: $reason) {
            vaultId
            grantedUntil
            indefinite
        }
    }
`;

/** Revoke a vault's Complimentary Pro now. Idempotent: an already-lapsed grant reports success. */
export const revokeProMutation = graphql`
    mutation proGrantMutationsRevokeProMutation($vaultId: UUID!, $reason: String!) {
        revokePro(vaultId: $vaultId, reason: $reason) {
            vaultId
            proUntil
        }
    }
`;
